/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type UtilisateurType = {
  /** Identifiant CIM de l'utilisateur. */
  identifiant: number | string;
  /** Login utilisé pour se connecté à 360. */
  login: string;
  /** Nom de l'utilisateur. */
  nom: string;
  /** Prénom de l'utilisateur. */
  prenom: string;
  /** Adresse email de l'utilisateur. */
  email: string;
  /** Profil de l'utilisateur métier connecté. */
  profil: {
    /** */
    identifiant: string | number;
    /** */
    nom: string;
    /** */
    administrateur: boolean;
    /** */
    gamme: 'horizon' | 'millesime' | 'interco';
    /** Prend en charge ou non le franc pacifique.  */
    pacification?: boolean;
  };
};

type UtilisateurStoreType = {
  utilisateur: null | UtilisateurType;
  setUtilisateur: (utilisateur: UtilisateurType) => void;
};

const fakeConnectedUtilisateur: UtilisateurType = {
  identifiant: 1000,
  login: 'axel.morlet',
  nom: 'MORLET',
  prenom: 'Axel',
  email: 'axel.morlet@jvs.fr',
  profil: {
    identifiant: 2,
    nom: 'Administrateur',
    administrateur: true,
    gamme: 'horizon',
  },
};

const useUtilisateurStore = create<UtilisateurStoreType>()(
  devtools((set) => ({
    utilisateur:
      process.env.NODE_ENV === 'development' ? fakeConnectedUtilisateur : null,
    setUtilisateur: (utilisateur) => set({ utilisateur }),
  })),
);

export default useUtilisateurStore;
